// see https://github.com/orgs/vuejs/discussions/11798
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { type RouteRecordRaw } from 'vue-router';
import { Navigation } from '@/router/navigation';
import { requireLoggedIn } from '@/router/guards/require-logged-in';
import { initNavAreaMyArea } from '@/router/guards/init-nav-area';
import { setNavAreaSwitchEnd, setNavAreaSwitchStart } from './guards/set-nav-area-switch';
import { OrderListTaskListViewMode } from '@/suppliers/types/OrderListTaskListViewMode.ts';

export const supplierRoutes: RouteRecordRaw = {
    path: 'suppliers',
    component: async () => import('@/suppliers/views/SuppliersRouterView.vue'),
    beforeEnter: [setNavAreaSwitchStart, requireLoggedIn, initNavAreaMyArea, setNavAreaSwitchEnd],
    children: [
        {
            path: 'depot-stock',
            name: Navigation.DepotStock,
            component: async () => import('@/suppliers/depot-stock/views/DepotStockView.vue'),
            meta: {
                titleKey: 'TITLES.DEPOT_STOCK',
            },
        },
        {
            path: 'input-type-demo',
            name: 'input-type-demo',
            component: async () => import('@/suppliers/views/InputTypesDemoView.vue'),
            meta: {
                titleKey: 'TITLES.DEPOT_STOCK',
            },
        },
        {
            path: 'depot-stock/detail/:id',
            name: Navigation.ContainerTimeline,
            component: async () => import('@/suppliers/container-timeline/views/ContainerTimelineView.vue'),
            meta: {
                titleKey: 'TITLES.CONTAINER_TIMELINE',
            },
            props: true,
        },
        {
            path: 'orders',
            name: Navigation.PurchaseOrderList,
            component: async () => import('@/suppliers/orders/views/OrderListTaskListView.vue'),
            props: () => ({
                activeMode: OrderListTaskListViewMode.ORDERS,
            }),
            meta: {
                titleKey: 'TITLES.PURCHASE_ORDERS',
            },
        },
        {
            path: 'tasks',
            name: Navigation.TaskList,
            component: async () => import('@/suppliers/orders/views/OrderListTaskListView.vue'),
            props: () => ({
                activeMode: OrderListTaskListViewMode.TASKS,
            }),
            meta: {
                titleKey: 'TITLES.SUPPLIER_TASKS',
            },
        },
        {
            path: 'orders/details/:id',
            name: Navigation.PurchaseOrderDetail,
            component: async () => import('@/suppliers/order-details/views/OrderDetailView.vue'),
            meta: {
                titleKey: 'TITLES.PURCHASE_ORDER_DETAILS',
            },
            props: true,
        },
    ],
};
